import axios from '@/plugins/axios';

const evalLLMUrl = '/api/llms';

export const getEvalLLMs = async () => {
    const response = await axios.get(evalLLMUrl);
    return response;
}

export const getEvalLLMById = async (id) => {
    const response = await axios.get(`${evalLLMUrl}/${id}`);
    return response;
}

export const createEvalLLM = async (data) => {
    const response = await axios.post(evalLLMUrl, data);
    return response;
}

export const updateEvalLLM = async (id, data) => {
    const response = await axios.patch(`${evalLLMUrl}/${id}`, data);
    return response;
}

export const deleteEvalLLM = async (id) => {
    const response = await axios.post(`${evalLLMUrl}/${id}/delete`);
    return response;
}

export const toggleEvalLLMActive = async (id, currentActive) => {
    
    const response = await axios.patch(`${evalLLMUrl}/${id}`, {
        active: !currentActive
    });
    
    return response;
}